import { connect } from 'react-redux';
import React, { Component } from 'react';
import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import { Routes, Route } from 'react-router-dom';
import { AuthenticationContext } from 'react-adal';
import { acquiredAccessTokenSuccess, appSettingsSucess } from './actions/app';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import TenantRegistration from './Components/Registration/TenantRegistration';
import Layout from './Components/Layout/Layout';
import * as Helper from './Helpers/Helper';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authProvider: null,
      tenantName: null,
      tenantId: null,
      clientid: null,
    }
  }

  componentDidMount = () => {
    this.getinitialData();
  }
  getinitialData = () => {
    if (this.state.tenantId === null) {
      Helper.fetchWebAPIResponseJsonWithBasicAuth(`api/settings/get`).then(data => {
        if (data && data.appId && data.tenantName && data.tenantId) {
          this.props.appSettingsSucess(data);
          this.setState({
            tenantName: data.tenantName,
            tenantId: data.tenantId,
            clientid: data.appId,
          },
            () => {
              this.initializeAuthProvider(data);
            })
        }
      });
    }
  }
  auth = null;
  initializeAuthProvider = data => {
    if (this.state.authProvider === null) {
      this.auth = new MsalAuthProvider(
        {
          auth: {
            authority: `https://login.microsoftonline.com/${this.state.tenantId}`, // process.env.REACT_APP_AUTHORITY,
            clientId: data.appId, // process.env.REACT_APP_AAD_APP_CLIENT_ID,
            postLogoutRedirectUri: window.location.origin,
            redirectUri: window.location.origin,
            validateAuthority: true,
            navigateToLoginRequestUrl: false,
            loadFrameTimeout: 7200000,
          },
          cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: true,
          },
          system: {
            loadFrameTimeout: 7200000,
          },
        },
        {
          scopes: ["offline_access","openid", "profile", "email", "Directory.AccessAsUser.All"],
        },
        {
          loginType: LoginType.Popup,
          tokenRefreshUri: `${window.location.origin}`,
        },
      )
      this.setState({ authProvider: this.auth }, () => {
        if (this.state.tenantId !== null) {
          const adalConfig = {
            tenant: this.state.tenantId,
            clientId: this.state.clientid,
            cacheLocation: 'localStorage',
            navigateToLoginRequestUrl: true,
          };
          if (this.authContext === undefined || this.authContext === null) {
            this.authContext = new AuthenticationContext(adalConfig);
          }
          const cachedIdToken = this.authContext.getCachedToken(adalConfig.clientId);
          if (cachedIdToken) {
            this.authContext.acquireToken("https://graph.microsoft.com", (error, accessToken) => {
              this.props.acquiredAccessTokenSuccess(accessToken);
            })
          }
        }
      });
    }
  };

  logout = () => {
    Helper.clearLocalStorage();
    this.state.authProvider.logout();
    this.setState({ authProvider: null });
  }

  render() {
    return (
      <div className="App">
        {
          this.state.authProvider &&
          <Layout logout={this.logout} props={this.props} authProvider={this.state.authProvider} >
            <Routes>
                <Route exact path='/' element={<TenantRegistration authProvider={this.state.authProvider} logout={this.logout} store={this.props.store} />} />
            </Routes>
          </Layout>
        }
      </div>
    )
  }
}
const mapDispatchToProps = dispatch => ({
  acquiredAccessTokenSuccess: token => {
    dispatch(acquiredAccessTokenSuccess(token));
  },
  appSettingsSucess: data => {
    dispatch(appSettingsSucess(data));
  },
});
const mapStateToProps = state => ({
  userToken: {
    jwtAccessToken: state.aad.accessToken?.accessToken ?? '',
    idToken: state.aad.idToken ? state.aad.idToken.idToken.rawIdToken : '',
    userDetails: state.aad.account
  }
});
export default
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App);